// extracted by mini-css-extract-plugin
export var container = "_fk-0";
export var icon = "_fk-1";
export var text = "_fk-2";